// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"3dc3f8d4","386":"2326d80c","407":"c21cafc2","920":"08230722","965":"469c8327"}[chunkId] + ".chunk.js";
};